import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { ourServices } from "../lib/servicesContent";

export default function MobileServices() {
  const responsive = {
    allp: {
      breakpoint: { max: 3000, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  return (
    <section className="w-full px-4 py-10 lg:hidden">
      <h2 className="mb-12 text-center text-lg font-bold text-primaryColor md:text-xl">
        {ourServices?.title}
      </h2>
      <Carousel
        responsive={responsive}
        swipeable={true}
        draggable={false}
        showDots={true}
        infinite={true}
        autoPlay={false}
        // customTransition="all .5"
        transitionDuration={500}
      >
        {ourServices.content.map((feature, index) => {
          return (
            <div className="mb-6 px-6" key={index}>
              <div className="flex w-full flex-col items-center justify-center gap-5 rounded-3xl bg-slate-300 p-6">
                <h2 className="text-center text-lg font-bold text-primaryColor md:text-xl">
                  {feature.title}
                </h2>

                <p className="text-base md:text-lg">{feature.body}</p>

                {feature.subContent?.map((subFeature, index) => {
                  return (
                    <div
                      key={index}
                      className="w-full rounded-3xl bg-white p-4"
                    >
                      <p className="text-sm md:text-base">{subFeature}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </Carousel>
    </section>
  );
}
